import React from 'react'



export const OtrosServicios = () => {
  return (
    <div>
        
          <div className="contenedor-clasico">
            <h1>Ofrecemos</h1>
            <h2>Impresiones</h2>
            <img className="imageContenedor" src="https://tecnographic.net/wp-content/uploads/2024/10/Que-es-la-impresion-laser-y-para-que-se-utiliza.jpg" style={{width: "calc(1px + 100vmin)", height: "calc(1px + 100vmin)", borderRadius:"100px"}}/>
            <h2>Engarolados</h2> 
           
            <img className="imageContenedor" src="https://speedy.uenicdn.com/5f652135-121a-4f5d-9fef-853cd43735f1/c960_a/image/upload/v1572515514/business/f3690779-3566-4410-aa1f-6026e85fab8c.png" 
            style={{width: "calc(1px + 100vmin)", height: "calc(1px + 100vmin)", borderRadius:"100px"}}/>
            <h2>Escaneos</h2>
            <img className="imageContenedor" src="https://argontech.com.ar/wp-content/uploads/2019/04/escaneo-integrado.png"
            style={{width: "calc(1px + 100vmin)", height: "calc(1px + 100vmin)", borderRadius:"100px"}}/>
            <h2>Enmicados</h2>
            <img className="imageContenedor" src="https://www.fpsf.mx/cdn/shop/products/845266-MLM25942805881_092017-O_49134fa6-e4d2-44de-b9c0-fad4c11ccbd5_500x500.jpg?v=1611879515" 
            style={{width: "calc(1px + 100vmin)", height: "calc(1px + 100vmin)", borderRadius:"100px"}}/>

        </div>

    </div>
  )
}
